import React, {useCallback, useEffect, useState, useRef, useMemo} from 'react';
import { useDispatch } from 'react-redux';
import {alertService} from '@app/services/alertService';
import Select from 'react-select';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName, getDefaultSelectValue} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole, createObj, updateObj} from '@app/services/mainService';
import {Button, Modal} from "react-bootstrap";
import {useSelector} from "react-redux";
import {Tabs} from "@components";
import {
    image_root,
    SERVER_DATE_FORMAT, SERVER_YYYYMM_FORMAT, template_upload_root
} from "@app/const/AppSetting";


import {useTranslation} from "react-i18next";
import {phanquyenService} from "@app/services/phanquyenService";
import MyReactDatePicker from "@app/utils/MyReactDatePicker";
import Cropper from 'react-easy-crop'

import EasyCrop from "@app/utils/EasyCrop";
import getCroppedImg from "@app/utils/Crop";
import {uploadService} from "@app/services/uploadService";
import {dataURLtoFile} from "@app/utils/CommonFunctions";
import {DateTime} from "luxon";
//import "@app/utils/myCss.css"
import moment from "moment";
function Uploads({ history }) {

    const [t] = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();

    const currController = getControllerName(location.pathname);
    const [loading, setLoading] = useState(false);
    const initSelect = [];


    const [handleToogle, setHandleToogle] = useState(false);

    const [image, setImage] = useState(null);

    const initial = {

        uploadType: '',
        yyyyMm :  moment().format(SERVER_YYYYMM_FORMAT),
        fileUpload : null

    };

    const [obj, setObj] = useState({...initial});

    const [dataset, setDataset] = useState([]);
    const [listUploadType, setListUploadType] = useState([]);
    const [listYyyyMM, setListYyyyMM] = useState([]);



    const [currentFile, setCurrentFile] = useState(null);

    const uploadFile = async (ObjectURL) => {
        //setLoading(true);
        let file = await fetch(ObjectURL).then(r => r.blob())
            .then(blobFile => new File([blobFile], currentFile.name))
        const res = await uploadService.postUpload(file);
        console.log('msg='+ res.msg);
        /*if(res.status ==="1")
        {
            let target = {name: imageType, value:  res.msg};
            onChangeInput({target});
        }*/


    };

    const uploadFile_direct = async (e) => {


        if( e.target.files[0])
        {
            console.log('uploadFile_direct='+ e.target.files[0].name);

            //setLoading(true);
            const file = e.target.files[0];
            const res = await uploadService.postUpload(file);
            console.log('msg='+ res.msg);
            if(res.status ==="1")
            {
                let target = {name: e.target.id, value:  res.msg};
                onChangeInput({target});
            }
           // setLoading(false);
        }
    };


    function getFormData(object) {
        const formData = new FormData();
        Object.keys(object).forEach(key => {
            formData.append(key, object[key]);
        })
        return formData;
    }



    const onChangeInput = async (e) => {
        const {name, value, checked, files} = e.target;
        //  console.log(name);
        //   console.log(value);

        let tmp_obj = obj;
        if (name === "yyyyMm") {
            tmp_obj[name] = value === 'false' || value === 'true' ? checked : value;
            await createRs();
        }
        if (name === "fileUpload") {
            if (files) {
                tmp_obj[name] = files[0];
            }
        } else
            tmp_obj[name] = value === 'false' || value === 'true' ? checked : value;

        setObj(tmp_obj);

        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });

    };

    const createRs = async () => {
        setLoading(true);
        const dataset = await  uploadService.getListStandard(obj);
        setDataset(dataset);
        console.log('dataset', JSON.stringify(dataset, null, 2));
        if(dataset )
        {
            setListYyyyMM(dataset.yyyyMM);
            setListUploadType(dataset.uploadType);



        }

        setLoading(false);


    };


    const isEmail = (email) =>
        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

    useEffect(async () => {
       /* await checkRole({
            pathname: location.pathname,
            isAddMode,
            currController,
            history
        });*/

        await createRs();

    }, []);

    const saveClick = async () => {
        let data = obj;
       if(!data || !data.yyyyMm || data.yyyyMm.length <= 0)
        {
            alertService.error( "Vui lòng chọn năm/tháng áp dụng",);
            return;
        }
        if(!data  || !data.uploadType ||   data.uploadType.length <= 0)
        {
            alertService.error( "Vui lòng chọn loại upload",);
            return;
        }

        if(!data ||   !data.fileUpload)
        {
            alertService.error( "Vui lòng file",);
            return;
        }


        createUser(data);


    };

    const backBrowse = () => {
        history.push('/'+currController);
    };

    async function createUser(data) {
        setLoading(true);
        const form = getFormData(data);
        console.log(form);
        const result = await uploadService.ImportStandard(form);
        if (result.status==="1") {

            alertService.success(result.msg,);

        } else {
            alertService.error(result.msg,);
        }
        setLoading(false);

    }


    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }


    let CURRENT_HEADER = 'Upload';


    // eslint-disable-next-line no-shadow
    return (

        <div className="card card-primary">
            <HeaderClick
                headerName={CURRENT_HEADER}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                <div className="form-row p-2">

                    <Button style={{marginLeft:10}} className="btn btn-primary"
                            onClick={saveClick}><i className="fa fa-save"> Tải file lên hệ thống</i></Button>

                </div>
                <div className="row">
                    <div className="col-md-4">
                        <label className="required"htmlFor="yyyyMm">Tháng năm</label>
                        <Select
                            name="yyyyMm"
                            options={listYyyyMM}
                            value={getDefaultSelectValue(
                                listYyyyMM,
                                obj.yyyyMm
                            )}
                            isClearable

                            /* eslint-disable-next-line no-unused-vars */
                            onChange={(opt, e) => {
                                const target = {name: "yyyyMm", value: opt?.value};
                                onChangeInput({target});

                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <label className="required"htmlFor="uploadType">Loại Upload</label>
                        <Select
                            name="uploadType"
                            options={listUploadType}
                            value={getDefaultSelectValue(
                                listUploadType,
                                obj.uploadType
                            )}
                            isClearable

                            /* eslint-disable-next-line no-unused-vars */
                            onChange={(opt, e) => {
                                const target = {name: "uploadType", value: opt?.value};
                                onChangeInput({target});

                            }}
                        />
                        {
                            obj.uploadType && (  <strong>

                                <a
                                    href={  template_upload_root + obj.uploadType +'.xlsx'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Template Upload.........
                                </a>
                                <span>.</span>
                            </strong>)
                        }
                    </div>

                </div>

                <div className="row">

                    <div className="col-md-4">
                        <label className="required"htmlFor="fileUpload">File upload</label>
                        <input id ='fileUpload' name ="fileUpload" type="file"  className="form-control"  onChange={onChangeInput} />
                    </div>
                </div>


            </div>

            <div className="card-footer">

            </div>
        </div>

    );
}

export {Uploads};
